import el from 'date-fns/locale/el';
import enUS from 'date-fns/locale/en-US';

const localeMap = {
  el,
  en: enUS,
};

export default localeMap;